import {
    ADD_MESSAGE,
    COMPLETE_MEETING,
    COMPLETE_MESSAGE,
    PROGRESS_DAY,
    PROGRESS_TIME,
    REMOVE_PHONE_CALL,
    EXIT_GAME,
    SET_CALENDAR,
    SET_ALL_MEETINGS,
    SET_ALL_MESSAGES,
    SET_MEETINGS_INDEXES,
    SET_MESSAGES_INDEXES,
    SET_PHONE_CALL,
    UPDATE_OVERALL_SCORES,
    SUBMIT_GAME_PLAYED,
    FAIL_WEEK,
} from '../constants/actions';
import { returnUpdatedScores } from '../helpers/active-game';
import { addNewMessageOrMeeting } from '../helpers/story-mode';

export const progressTime = gamePlayed => {
    return (dispatch, getState) => {
        const state = getState();
        const {
            currentDay,
            messagesIndexes,
            meetingsIndexes,
        } = state.activeGame;

        if (currentDay === 0) {
            dispatch({
                type: ADD_MESSAGE,
                message: messagesIndexes[0],
            });
        } else if (meetingsIndexes.length > 0 || messagesIndexes.length > 0) {
            dispatch(addNewMessageOrMeeting(state));
        }

        dispatch({
            type: SUBMIT_GAME_PLAYED,
            gamePlayed,
        });

        dispatch({
            type: PROGRESS_TIME,
        });
    };
};

export const progressDay = () => {
    return {
        type: PROGRESS_DAY,
    };
};

export const updateOverallScores = (previousScores, gameScores) => {
    const overallScores = returnUpdatedScores(previousScores, gameScores);
    return {
        type: UPDATE_OVERALL_SCORES,
        overallScores,
    };
};

export const exitGame = () => {
    return {
        type: EXIT_GAME,
    };
};

export const setMessagesIndexes = messagesIndexes => {
    const presetMessages = messagesIndexes.splice(0, 2);

    return {
        type: SET_MESSAGES_INDEXES,
        presetMessages,
        messagesIndexes,
    };
};

export const setAllMessages = messages => {
    return {
        type: SET_ALL_MESSAGES,
        messages,
    };
};

export const completeMessage = messageIndex => {
    return {
        type: COMPLETE_MESSAGE,
        messageIndex,
    };
};

export const setMeetingsIndexes = meetingsIndexes => {
    const presetMeetings = meetingsIndexes.splice(0, 2);

    return {
        type: SET_MEETINGS_INDEXES,
        presetMeetings,
        meetingsIndexes,
    };
};

export const setAllMeetings = meetings => {
    return {
        type: SET_ALL_MEETINGS,
        meetings,
    };
};

export const completeMeeting = meetingIndex => {
    return {
        type: COMPLETE_MEETING,
        meetingIndex,
    };
};

export const setCalendar = calendar => {
    return {
        type: SET_CALENDAR,
        calendar,
    };
};

export const setCurrentPhoneCall = phoneCallId => {
    return (dispatch, getState) => {
        const { calendar, currentDay } = getState().activeGame;

        let currentCall;
        if (phoneCallId === 'call_gfailed' || phoneCallId === 'call_ofailed') {
            currentCall = {
                taskType: 'fail',
                phone_callID: phoneCallId,
            };
            dispatch({
                type: FAIL_WEEK,
            });
        } else {
            currentCall = calendar[currentDay].call.filter(
                call => call.phone_callID === phoneCallId,
            )[0];
        }

        dispatch({
            type: SET_PHONE_CALL,
            currentCall,
        });
    };
};

export const removePhoneCall = phoneCallId => {
    return (dispatch, getState) => {
        const { calendar } = getState().activeGame;
        const newCalendar = calendar.reduce((arr, day) => {
            let revisedDay = {};
            if (day.call[0]) {
                revisedDay = {
                    ...day,
                    call: day.call.filter(
                        call => call.phone_callID !== phoneCallId,
                    ),
                };
            } else {
                revisedDay = day;
            }
            return [...arr, revisedDay];
        }, []);

        dispatch({
            type: REMOVE_PHONE_CALL,
            newCalendar,
        });
    };
};
